import React from 'react'
import FileItem, { FileItemProps } from './HomeFileItem'
import './styles/homeresult.css'

export interface HomeResultProps extends FileItemProps {
  resultComponent: React.ElementType
}

const HomeResult = (props: HomeResultProps) => {
  return (
    <div className="homeResult">
      {/* Create the component set in props and pass its dedicated props */}
      {props.resultComponent &&
        React.createElement(props.resultComponent, props.processingResult)}
      <FileItem
        fileName={props.fileName}
        processingResult={props.processingResult}
        handleDownloadResult={props.handleDownloadResult}
      />
    </div>
  )
}

export default HomeResult
